import { CONFIG_URL } from '../helpers/constants'

const api = {
   URI_ENDPOINT: CONFIG_URL.SERVICE_URL,
   auth: {
      refreshToken: '/auth/refresh-tokens',
      login: '/auth/login', // API I: API Signin
      register: '/auth/register',
      getUserInfo: '/auth/getUserInfo',
      updateInfo: '/auth/updateInfo',
      changePassword: '/auth/changePassword',
      resetPassword: '/auth/reset-password',
      forgotPassword: '/auth/forgot-password',
      logout: '/sign-out', // API II: API SignOut
      verifyEmail: '/auth/verify-email',
      sendEmail: '/auth/send-verification-email'
   },
   upload: {
      uploadFile: '/upload',
      getUploadUrl: '/file/upload', // API III: API lấy preSignedUrl upload file
      getViewUrl: '/file/retrieve', // API IV: API lấy preSignedUrl view file
      remove: '/file/remove' // API: API xoá file upload
   },

   user: {
      getDropdownUsername: '/user/dropdown-username', // API XXVII: API lấy dropdown hiển thị tất cả username đang hoạt động
      getProfile: '/profiles', // API XII: API lấy thông tin user info
      updateProfile: '/profiles',
      changePassword: '/profiles/change-password',
      transaction: '/profiles/transaction'
   },

   promotions: {
      getList: '/promotions',
      create: '/promotions',
      update: '/promotions',
      delete: '/promotions'
   },
   provinces: {
      getList: '/provinces/search',
      create: '/provinces',
      update: '/provinces',
      delete: '/provinces'
   },
   districts: {
      getList: '/districts/search',
      create: '/districts',
      update: '/districts',
      delete: '/districts'
   },
   prices: {
      getList: '/route-prices/active',
      update: '/route-prices/'
   },

   managerUser: {
      getUser: '/users',
      create: '/users',
      update: '/users',
      delete: '/users',
      transaction: '/users/transaction'
   },
   notification: {
      getNotifications: '/notifications/user',
      create: '/notifications/send-by-role'
   },
   config: {
      create: '/config',
      update: '/config',
      getList: '/config',
      getListSupport: '/config/get-link-support'
   },
   debt: {
      getList: '/debts',
      total: 'debts/total'
   },
   funds: {
      create: '/funds',
      update: '/funds',
      approve: '/funds/approve',
      getList: '/funds',
      total: '/funds/total'
   },
   order: {
      getOrders: '/orders',
      create: '/orders',
      update: '/orders',
      cancel: '/orders/:id/cancel',
      delete: '/orders'
   },
   routePrice: {
      getRoute: 'route-prices/active'
   },
   dashboard: {}
}

export default api
